var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('spinner',{attrs:{"line-fg-color":"#F9BB13","line-bg-color":"FFF"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }